<template>
  <div class="backtest-bollinger-optimize-view">
    <BacktestBollingerOptimize />
  </div>
</template>

<script>
import BacktestBollingerOptimize from '@/components/quant-trading/BacktestBollingerOptimize.vue'

export default {
  name: 'BacktestBollingerOptimizeView',
  components: { BacktestBollingerOptimize }
}
</script>

<style scoped>
.backtest-bollinger-optimize-view {
  width: 100%;
  height: 100%;
}
</style>
